import { NavigationConfigConstants } from './Navigation.constants';

const initialState = {
  subMenu: [],
  menusInitialState: {
    list: []
  },
  permissions: {}
};

const NavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NavigationConfigConstants.GET_NAVIGATION_REQUEST:
      return {
        ...state,

        loading: true,
        error: false
      };

    case NavigationConfigConstants.GET_NAVIGATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...action.payload
      };

    case NavigationConfigConstants.GET_NAVIGATION_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      };

    case NavigationConfigConstants.GET_AVAILABLE_NAVIGATION_REQUEST:
      return {
        ...state,
        menusInitialState: {
          loading: true,
          error: false
        }
      };

    case NavigationConfigConstants.GET_AVAILABLE_NAVIGATION_SUCCESS:
      return {
        ...state,
        menusInitialState: {
          loading: false,
          error: false,
          list: action.payload
        }
      };

    case NavigationConfigConstants.GET_AVAILABLE_NAVIGATION_ERROR:
      return {
        ...state,
        menusInitialState: {
          loading: false,
          error: true
        }
      };

    case NavigationConfigConstants.GET_FEATURES_REQUEST:
      return {
        ...state,
        features: {
          loading: true,
          error: false
        }
      };

    case NavigationConfigConstants.GET_FEATURES_SUCCESS:
      return {
        ...state,
        features: {
          loading: false,
          error: false,
          list: [...action.payload]
        }
      };

    case NavigationConfigConstants.GET_FEATURES_ERROR:
      return {
        ...state,
        features: {
          loading: false,
          error: true
        }
      };

    case NavigationConfigConstants.GET_SUBNAVIGATION_SUCCESS:
      return {
        ...state,
        subMenu: action.payload
      };

    case NavigationConfigConstants.GET_NAVIGATION_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        permissions: action.payload
      };

    case NavigationConfigConstants.GET_NAVIGATION_ORDER:
      return {
        ...state,
        loading: false,
        error: false,
        order: action.payload
      };

    default:
      return state;
  }
};

export default NavigationReducer;
